/**
 * variant-matrix-fix.js
 * 
 * SORUN: Shopify'da bir ürünün birden fazla seçenek grubu varsa (örn. DIMENSIONS + METAL LEGS),
 * bazı kombinasyonlar hiç varyant olarak tanımlanmamış olabilir (örn. 140*70*5 + 5 ayak = yok).
 * Tema bu durumda o seçenek butonlarına "Sold Out" tooltip'i gösteriyor.
 * Fakat aslında 5 ayak başka boyutlarda var — sorun kombinasyonun olmaması, stoksuzluk değil.
 * Cmd+R ile düzelmesi: hard refresh'te sayfa farklı bir varyantla başlıyor şans eseri.
 *
 * ÇÖZÜM: Seçenek değiştiğinde, mevcut seçime göre diğer seçeneklerin hangilerinin
 * geçerli/stokta/mevcut olmadığını gerçek varyant matrisine göre hesapla ve
 * "unavailable" (yoktur) ile "sold_out" (vardır ama stokta yok) arasındaki farkı doğru göster.
 *
 * KURULUM: Bu dosyayı Shopify tema assets'ine yükle ve product template'inde
 * <script src="{{ 'variant-matrix-fix.js' | asset_url }}" defer></script> olarak ekle.
 */

(function () {
  'use strict';

  // ─── Yardımcı: sayfada ürün JSON'ı bul ya da API'den çek ──────────────────
  function getProductJSON(callback) {
    // 1) Tema zaten window.productJSON sağlıyorsa kullan
    if (window.productJSON && window.productJSON.variants) {
      return callback(window.productJSON);
    }
    // 2) data-product-json attribute'ü olan element varsa
    var el = document.querySelector('[data-product-json]');
    if (el) {
      try {
        var parsed = JSON.parse(el.getAttribute('data-product-json'));
        if (parsed && parsed.variants) return callback(parsed);
      } catch (e) {}
    }
    // 3) Yedek: URL'den handle al, /products/handle.js'den çek
    var parts = window.location.pathname.split('/');
    var idx = parts.indexOf('products');
    if (idx === -1) return;
    var handle = parts[idx + 1];
    if (!handle) return;
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (data) { callback(data); })
      .catch(function () {});
  }

  // ─── Varyant matrisini işle ───────────────────────────────────────────────
  function buildMatrix(variants, optionCount) {
    /**
     * Her seçenek pozisyonu için, o seçenekteki her değerin
     * hangi durumda olduğunu tutar:
     *   'available'   → en az bir matching varyant stokta
     *   'sold_out'    → en az bir matching varyant var ama hepsi stoksuz
     *   'unavailable' → bu seçim için matching varyant hiç yok
     */
    var matrix = {}; // matrix[optPos][value] = 'available' | 'sold_out' | 'unavailable'
    for (var i = 0; i < optionCount; i++) {
      matrix[i] = {};
    }
    variants.forEach(function (v) {
      for (var pos = 0; pos < optionCount; pos++) {
        var val = v['option' + (pos + 1)];
        if (!val) continue;
        if (!matrix[pos][val] || matrix[pos][val] === 'unavailable') {
          matrix[pos][val] = v.available ? 'available' : 'sold_out';
        } else if (matrix[pos][val] === 'sold_out' && v.available) {
          matrix[pos][val] = 'available';
        }
      }
    });
    return matrix;
  }

  function buildFilteredMatrix(variants, optionCount, currentSelections) {
    /**
     * currentSelections: { 0: '180*90*5', 1: null } gibi —
     * null olan pozisyon "seçilmemiş / hepsi geçerli"
     * Seçili olan pozisyonlar için o seçimle uyumlu varyantları filtrele,
     * sonra diğer pozisyonlardaki değerlerin durumunu hesapla.
     */
    var filtered = variants.filter(function (v) {
      for (var pos = 0; pos < optionCount; pos++) {
        var sel = currentSelections[pos];
        if (sel !== null && sel !== undefined && v['option' + (pos + 1)] !== sel) {
          return false;
        }
      }
      return true;
    });

    var result = {};
    for (var i = 0; i < optionCount; i++) {
      result[i] = {};
    }

    // Önce tüm bilinen değerleri 'unavailable' olarak işaretle
    variants.forEach(function (v) {
      for (var pos = 0; pos < optionCount; pos++) {
        var val = v['option' + (pos + 1)];
        if (val && !result[pos][val]) {
          result[pos][val] = 'unavailable';
        }
      }
    });

    // Filtrelenmiş varyantlardan durumu güncelle
    filtered.forEach(function (v) {
      for (var pos = 0; pos < optionCount; pos++) {
        var val = v['option' + (pos + 1)];
        if (!val) continue;
        if (result[pos][val] === 'unavailable') {
          result[pos][val] = v.available ? 'available' : 'sold_out';
        } else if (result[pos][val] === 'sold_out' && v.available) {
          result[pos][val] = 'available';
        }
      }
    });

    return result;
  }

  // ─── DOM: Swatch input'larını bul ve durumlarını güncelle ─────────────────
  function getOptionInputs(optPos) {
    // Tema .swatch__input[data-option-index] veya .single-option-selector kullanıyor
    var byAttr = document.querySelectorAll('.swatch__input[data-option-index="' + optPos + '"]');
    if (byAttr.length) return Array.from(byAttr);

    // Alternatif: index sırasına göre select
    var selects = document.querySelectorAll('.single-option-selector');
    if (selects[optPos]) return [selects[optPos]];

    return [];
  }

  function getAllOptionInputs() {
    var inputs = document.querySelectorAll('.swatch__input');
    if (inputs.length) return Array.from(inputs);
    return Array.from(document.querySelectorAll('.single-option-selector option'));
  }

  function getCurrentSelections(optionCount) {
    var sel = {};
    for (var i = 0; i < optionCount; i++) {
      var inputs = getOptionInputs(i);
      sel[i] = null;
      inputs.forEach(function (inp) {
        if (inp.checked || (inp.tagName === 'SELECT' && inp.value)) {
          sel[i] = inp.value;
        }
      });
      // SELECT elementi
      if (sel[i] === null) {
        var selEl = document.querySelectorAll('.single-option-selector')[i];
        if (selEl && selEl.value) sel[i] = selEl.value;
      }
    }
    return sel;
  }

  // ─── Label'lara durum class'ı uygula ──────────────────────────────────────
  function applyStatusToLabel(input, status) {
    // Input'a karşılık gelen label'ı bul
    var label = null;
    if (input.id) {
      label = document.querySelector('label[for="' + input.id + '"]');
    }
    if (!label) {
      label = input.closest('label') || input.parentElement;
    }

    var target = label || input;

    // Önceki sınıfları temizle
    target.classList.remove('variant--available', 'variant--sold-out', 'variant--unavailable');
    input.classList.remove('variant--available', 'variant--sold-out', 'variant--unavailable');

    // Yeni sınıf ekle
    target.classList.add('variant--' + status.replace('_', '-'));
    input.classList.add('variant--' + status.replace('_', '-'));

    // Tooltip güncelle: sadece sold_out ve unavailable için
    var existingTip = target.querySelector('.variant-status-tip');
    if (existingTip) existingTip.remove();

    if (status === 'sold_out') {
      var tip = document.createElement('span');
      tip.className = 'variant-status-tip sold-out-tip';
      tip.textContent = 'Sold Out';
      target.appendChild(tip);
    } else if (status === 'unavailable') {
      // unavailable opsiyonlar için tooltip yok, sadece görsel işaret
      // (sadece CSS ile üstü çizili veya soluk gösterilecek)
    }

    // disabled state
    if (status === 'unavailable') {
      input.setAttribute('disabled', 'disabled');
    } else {
      input.removeAttribute('disabled');
    }
  }

  // ─── Ana güncelleme fonksiyonu ─────────────────────────────────────────────
  function updateOptionStatuses(variants, optionCount) {
    var currentSel = getCurrentSelections(optionCount);
    
    // Her pozisyon için: o pozisyon hariç diğerleri seçiliyken
    // o pozisyondaki değerlerin durumunu hesapla
    for (var pos = 0; pos < optionCount; pos++) {
      var selForPos = {};
      for (var k = 0; k < optionCount; k++) {
        selForPos[k] = (k === pos) ? null : currentSel[k];
      }
      
      var matrix = buildFilteredMatrix(variants, optionCount, selForPos);
      var statusMap = matrix[pos];

      var inputs = getOptionInputs(pos);
      inputs.forEach(function (inp) {
        var val = inp.value;
        var status = statusMap[val] || 'unavailable';
        applyStatusToLabel(inp, status);
      });
    }
  }

  // ─── CSS enjekte et ───────────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('variant-matrix-fix-styles')) return;
    var style = document.createElement('style');
    style.id = 'variant-matrix-fix-styles';
    style.textContent = [
      '/* variant-matrix-fix.js tarafından eklendi */',

      /* Kullanılamaz kombinasyonlar: üstü çizili, soluk */
      '.variant--unavailable {',
      '  opacity: 0.35 !important;',
      '  cursor: not-allowed !important;',
      '  position: relative;',
      '}',
      '.variant--unavailable::after {',
      '  content: "";',
      '  position: absolute;',
      '  left: 50%;',
      '  top: 50%;',
      '  width: 120%;',
      '  height: 1px;',
      '  background: currentColor;',
      '  transform: translate(-50%, -50%) rotate(-45deg);',
      '  opacity: 0.5;',
      '  pointer-events: none;',
      '}',

      /* Stok bitti kombinasyonlar: tooltip ile */
      '.variant--sold-out {',
      '  opacity: 0.55 !important;',
      '  cursor: not-allowed !important;',
      '  position: relative;',
      '}',

      /* Tooltip */
      '.variant-status-tip {',
      '  display: none;',
      '  position: absolute;',
      '  bottom: calc(100% + 6px);',
      '  left: 50%;',
      '  transform: translateX(-50%);',
      '  background: #1a1a1a;',
      '  color: #fff;',
      '  font-size: 11px;',
      '  white-space: nowrap;',
      '  padding: 3px 8px;',
      '  border-radius: 3px;',
      '  pointer-events: none;',
      '  z-index: 9999;',
      '}',
      '.variant--sold-out:hover .variant-status-tip,',
      '.variant--sold-out .variant-status-tip { display: block; }',
    ].join('\n');
    document.head.appendChild(style);
  }

  // ─── Event listener: herhangi bir seçenek değişince güncelle ──────────────
  function attachListeners(variants, optionCount) {
    // Swatch inputlar
    document.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;
      var isSwatch = t.classList && t.classList.contains('swatch__input');
      var isSingleOpt = t.classList && t.classList.contains('single-option-selector');
      if (isSwatch || isSingleOpt) {
        updateOptionStatuses(variants, optionCount);
      }
    });

    // Click eventleri de yakala (bazı temalar change tetiklemiyor)
    document.addEventListener('click', function (e) {
      var label = e.target.closest && e.target.closest('label[for]');
      if (!label) return;
      var forId = label.getAttribute('for');
      if (!forId) return;
      var inp = document.getElementById(forId);
      if (inp && inp.classList && inp.classList.contains('swatch__input')) {
        setTimeout(function () {
          updateOptionStatuses(variants, optionCount);
        }, 50);
      }
    });
  }

  // ─── Başlat ───────────────────────────────────────────────────────────────
  function init() {
    // Sadece ürün sayfasında çalış
    if (!document.getElementById('AddToCartForm') && !document.getElementById('AddToCart')) return;

    injectStyles();

    getProductJSON(function (product) {
      var variants = product.variants;
      if (!variants || !variants.length) return;

      var optionCount = product.options ? product.options.length : 1;
      if (optionCount < 2) return; // tek seçenek varsa sorun yok

      // İlk render
      updateOptionStatuses(variants, optionCount);

      // Değişiklik dinleyicileri
      attachListeners(variants, optionCount);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Section reload desteği (Shopify theme editor)
  document.addEventListener('shopify:section:load', init);

})();